<template>
	<div id="categories-movies-index" class="row-v2">
		<div class="col">
			
		</div>
	</div>
</template>

<script>
	export default {
		name: 'categories-movies-index',
		data () {
			return {
				movies: {}
			}
		},
		methods: {
			load() {

			}
		},
		created() {
			this.load();
		}
	}
</script>

<style lang="css" scoped>
</style>